import { render, staticRenderFns } from "./my-profile-button.vue?vue&type=template&id=f5eaa0a8&"
import script from "./my-profile-button.vue?vue&type=script&lang=ts&"
export * from "./my-profile-button.vue?vue&type=script&lang=ts&"
import style0 from "./my-profile-button.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
